import type { Flag, Level } from './Level'
import type { ContextDefault, ReglePreCallback, Regles, ReglesMembre } from './Regle'

export function addPreBuilder<TModelGlobalModel extends object, TContext = ContextDefault>() {
  // TModel extends object = any,
  // TRegles extends Regles<TModel, TContext, Level, Flag, TModelGlobalModel> = {},

  return function addPre<TModel extends object = any, TValue = any>(
    pre: ReglePreCallback<NoInfer<TModel>, NoInfer<TValue>, TContext, TModelGlobalModel>,
    regles:
      | Regles<TModel, TContext, Level, Flag, TModelGlobalModel>
      | ReglesMembre<TModel, TValue, TContext, Level, Flag, TModelGlobalModel>,
  ) {
    return Object.entries(regles).reduce((newRegles, [key, regle]) => {
      const newPre: ReglePreCallback<any, any, any>[] = [pre]
      if (Array.isArray((regle as any).pre)) {
        newPre.push(...(regle as any).pre)
      } else if ((regle as any).pre) {
        newPre.push((regle as any).pre)
      }
      newRegles[key] = {
        ...regle,
        pre: newPre,
      }
      return newRegles
    }, {} as any)
  }
}
